import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../../i18n';
import Exchange from '../../models/Exchange';
import User from '../../models/User';
import Tooltip from '../widget/Tooltip';
import { PercentageFormatter, CurrencyFormatter } from '../../utils/Intl';

export default class DepositRow extends React.Component {
    static propTypes = {
        currency: PropTypes.string.isRequired,
        exchange: PropTypes.instanceOf(Exchange).isRequired,
        user: PropTypes.instanceOf(User).isRequired
    };

    isGuest() {
        const guest = this.props.exchange.get('guest');
        return guest && guest.id == this.props.user.id;
    }

    render() {
        const { currency } = this.props;
        return (
            <div className="form-group editable-field deposit">
                <label>
                    {i18n.t('exchange:deposit')}
                    {this.isGuest() && (
                        <Tooltip
                            title={i18n.t('exchange:deposit_tooltip_guest', {
                                commission: PercentageFormatter.format(Exchange.COMMISSION_FACTOR),
                                value: CurrencyFormatter.format(this.props.exchange.getCommission(), currency)
                            })}
                        />
                    )}
                </label>
                {this.renderDeposit(this.props.exchange.get('home_deposit'))}
            </div>
        );
    }

    renderDeposit(value) {
        const { currency } = this.props;
        const detail = i18n.t('exchange:deposit_detail', {
            value: CurrencyFormatter.format(value, currency),
            commission_percentage: PercentageFormatter.format(Exchange.COMMISSION_FACTOR)
        });
        return (
            <span className="value">
                {detail}{' '}
                <span className="pull-right">
                    {CurrencyFormatter.format(Exchange.COMMISSION_FACTOR * value, currency)}
                </span>
            </span>
        );
    }
}
